import Axios from 'axios'
import { refreshInterceptor } from './apis'
import { sendSentryEvent } from '../lib/sentry'

export const ApiHCA = Axios.create({
    baseURL: process.env.REACT_APP_HCA_API,
})

ApiHCA.interceptors.response.use(
    ok => ok,
    error => refreshInterceptor(error, ApiHCA)
)

export const getMeetingTokens = (algorithm_id?: string | null) =>
    ApiHCA.post<GetTokensDTO>('/sdk_session/get_sdk_tokens', {
        algorithm_id: algorithm_id ?? undefined,
    }).then(({ data }) => {
        sendSentryEvent({
            message: 'Meeting tokens obtained successfully',
            level: 'info',
            tags: {
                endpoint: '/sdk_session/get_sdk_tokens',
                algorithm_id: algorithm_id || 'null',
                hasGeneral: !!data.general_room?.url,
                hasTeams: !!data.teams_room?.url,
                hasBoth: !!data.general_room?.url && !!data.teams_room?.url,
                validGeneralUrl: data.general_room?.url ? validateUrl(data.general_room?.url) : true,
                validTeamsUrl: data.teams_room?.url ? validateUrl(data.teams_room?.url) : true,
            },
            extra: {
                data,
                timestamp: new Date().toISOString(),
            },
        })
        return data
    })

interface GetTokensDTO {
    general_room?: {
        token?: string
        url: string
    }
    teams_room?: {
        token?: string
        table_number: number
        url: string
    }
}

const validateUrl = (rawUrl: string) => {
    const url = new URL(rawUrl)
    // Get query params
    const params = new URLSearchParams(url.search)
    const zoomToken = params.get('zoomToken')
    const widgetToken = params.get('widgetToken')
    const topic = params.get('topic')
    return !!topic && !!zoomToken && !!widgetToken
}
